import React from 'react';
import { StarIcon, CheckIcon } from 'lucide-react';
export function PricingCards() {
  const contents = [{
    title: '6 Módulos de Actividades Psicopedagógicas',
    detail: 'Concentración, funciones ejecutivas, matemática y razonamiento, lectoescritura, lenguaje y memoria.',
    value: '$39.990',
    highlight: true
  }, {
    title: 'Material práctico listo para usar',
    detail: 'Actividades organizadas para seleccionar, adaptar e imprimir según los objetivos de cada sesión.',
    value: '$24.990',
    highlight: false
  }, {
    title: '6 Bonos Profesionales',
    detail: 'Primera Consulta Resuelta · Evaluación Sin Caos · Sesiones Listas · Informes Sin Bloqueo · Salvá la Sesión · Seguimiento Sin Caos.',
    value: '$29.990',
    highlight: true
  }];
  return <section id="ofertas" className="w-full bg-transparent py-8" data-id="element-120" data-mp="2u1p5m1490ecw">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-121" data-mp="2z3xyyyl19ifj">
        <div className="text-center mb-6" data-id="element-122" data-mp="3tgwilbyzjc8q">
          <h2 className="md:text-3xl text-[14px] font-[800] font-[Montserrat,_sans-serif] text-[#FFFFFF]" data-id="element-123" data-mp="3thpfll856ndo">
            Más claridad, más recursos listos y una práctica mucho más
            profesional.
          </h2>
        </div>

        <div className="max-w-md mx-auto" data-id="element-124" data-mp="3jkt4r8urtp5y">
          {/* Premium */}
          <div id="oferta-pro" className="relative scroll-mt-24 bg-[#141414] border-2 border-[#C084FC]/50 rounded-2xl p-5 flex flex-col justify-between shadow-[0_0_30px_rgba(192,132,252,0.12)]" data-id="element-125" data-mp="3figabglh5doh">
            <div className="absolute -top-3 left-1/2 transform -translate-x-1/2" data-id="element-126" data-mp="b4zxlkmbxq1k">
              <div className="bg-[#C084FC] text-white px-4 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider flex items-center gap-1.5 whitespace-nowrap" data-id="element-127" data-mp="6admlik5tzi0">
                <StarIcon className="w-3 h-3 fill-current" aria-hidden="true" data-id="element-128" data-mp="ytj7g4l12avr" />
                Oferta de lanzamiento
              </div>
            </div>

            <div data-id="element-129" data-mp="tzy9udncjix3">
              <p className="text-[11px] md:text-xs uppercase tracking-[0.18em] text-[#D8B4FE] font-bold mb-4 mt-3 text-center leading-relaxed" data-id="element-130" data-mp="2o9wjo4xkqlz7">
                Todo lo que incluye PsicoKit Profesional™
              </p>

              {/* Content list with values */}
              <ul className="mb-5 divide-y divide-white/[0.06]" data-id="element-131" data-mp="2ehqvz7ecuqpt">
                {contents.map(item => <li key={item.title} className="flex gap-3 py-3.5 first:pt-1" data-id="element-132" data-mp="2jgk22erbbffy">
                    <CheckIcon className="w-4 h-4 text-[#C084FC] flex-shrink-0 mt-0.5" strokeWidth={3} aria-hidden="true" data-id="element-133" data-mp="25l85s2xidgwx" />
                    <div className="flex-1 min-w-0" data-id="element-134" data-mp="1vnbvfdceapzv">
                      <div className="flex items-start justify-between gap-3" data-id="element-135" data-mp="20l3ls2xe641y">
                        <p className={`text-[14px] md:text-[15px] leading-snug ${item.highlight ? 'text-white font-bold' : 'text-white font-semibold'}`} data-id="element-136" data-mp="3pygsfysz8468">
                          {item.title}
                        </p>
                        <span className="text-[12px] md:text-[13px] text-[#D8B4FE] font-bold whitespace-nowrap mt-0.5" data-id="element-137" data-mp="1ebn4up0f26qz">
                          {item.value}
                        </span>
                      </div>
                      <p className="text-[12px] md:text-[13px] text-gray-400 leading-snug mt-1" data-id="element-138" data-mp="1oa2t8k8271ws">
                        {item.detail}
                      </p>
                    </div>
                  </li>)}
              </ul>

              {/* Separator */}
              <div className="h-px bg-gradient-to-r from-transparent via-[#C084FC]/30 to-transparent mb-4" data-id="element-139" data-mp="1y1ysvzpsn034" />

              {/* Total value */}
              <div className="rounded-xl border border-white/[0.08] bg-[#0F0F0F] px-4 py-3 mb-3 flex items-center justify-between" data-id="element-140" data-mp="271c693h1g8t4">
                <span className="text-[10px] md:text-[11px] uppercase tracking-[0.18em] text-gray-400 font-bold" data-id="element-141" data-mp="hlmiewnis2cu">
                  Valor total del kit
                </span>
                <span className="text-gray-400 line-through text-lg md:text-xl font-[900]" data-id="element-142" data-mp="e2ndgbn5qm0j">
                  $94.970
                </span>
              </div>

              {/* Launch price */}
              <div className="rounded-xl border border-[#C084FC]/40 bg-[#1A1233] px-4 py-5 mb-3 text-center" data-id="element-143" data-mp="o2nyq34l7c7d">
                <p className="text-[10px] uppercase tracking-[0.25em] text-[#D8B4FE] font-bold mb-2" data-id="element-144" data-mp="t07e56d0tv0w">
                  Oferta de lanzamiento
                </p>
                <p className="text-[#C084FC] text-5xl md:text-6xl font-[900] leading-none tracking-tight" data-id="element-145" data-mp="biny2di7a3x">
                  $19.990
                </p>
              </div>

              <p className="text-[11px] md:text-xs text-gray-400 text-center mb-5" data-id="element-146" data-mp="59ag8xi28y8n">
                Pago único · Acceso inmediato · Material 100% digital
              </p>
            </div>

            <a href="https://seno-lista.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" className="block w-full bg-[#C084FC] hover:bg-[#9333EA] text-white text-center px-4 py-3.5 rounded-xl transition-colors duration-200 text-[18px] md:text-[20px] font-[700] font-[Poppins,_sans-serif]" data-id="element-147" data-mp="38pr5mfehmghb">
              QUIERO MI PSICOKIT AHORA
            </a>
          </div>
        </div>
      </div>
    </section>;
}